(function () {
  function parseCollectionInfo() {
    try {
      return JSON.parse(window.localStorage.getItem('collectionInfo'));
    } catch (error) {
      return null;
    }
  }

  function buildCollectionLink(collectionsUrl, collectionInfo) {
    var base = (collectionsUrl || '/collections').replace(/\/$/, '');
    var href = base + '/' + collectionInfo.handle;
    var scrollPosition = collectionInfo.scrollPosition;

    if (scrollPosition !== undefined && scrollPosition !== null && scrollPosition !== '') {
      href += '?scroll=' + encodeURIComponent(scrollPosition);
    }

    return href;
  }

  function injectCollectionBreadcrumb(nav, collectionInfo) {
    if (!nav || !collectionInfo || !collectionInfo.handle || !collectionInfo.title) {
      return false;
    }

    var list = nav.querySelector('.breadcrumbs__list');
    if (!list || list.querySelector('[data-breadcrumb-collection]')) {
      return false;
    }

    var currentItem = list.querySelector('li:last-child');
    if (!currentItem) {
      return false;
    }

    var collectionItem = document.createElement('li');
    collectionItem.setAttribute('data-breadcrumb-collection', 'true');

    var collectionLink = document.createElement('a');
    collectionLink.href = buildCollectionLink(nav.dataset.collectionsUrl, collectionInfo);
    collectionLink.className = 'breadcrumbs__link text xs grey';
    collectionLink.textContent = collectionInfo.title;

    collectionItem.appendChild(collectionLink);

    var separator = document.createElement('li');
    separator.className = 'breadcrumbs__separator';
    separator.textContent = '/';
    separator.setAttribute('data-breadcrumb-collection', 'true');

    list.insertBefore(collectionItem, currentItem);
    list.insertBefore(separator, currentItem);
    return true;
  }

  function initBreadcrumbs() {
    var collectionInfo = parseCollectionInfo();
    if (!collectionInfo) {
      return;
    }

    var navs = document.querySelectorAll('.breadcrumbs[data-collections-url]');
    var inserted = false;

    navs.forEach(function (nav) {
      inserted = injectCollectionBreadcrumb(nav, collectionInfo) || inserted;
    });

    if (inserted) {
      window.localStorage.removeItem('collectionInfo');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBreadcrumbs, { once: true });
  } else {
    initBreadcrumbs();
  }
})();
